import { useNavigate } from '@remix-run/react';
import { AuthKitProvider, useAuth } from '@workos-inc/authkit-react';

// Environment variables
// - in dev these need to be set in .env.local
// - in prod these will be added at build time (in github actions)
const { PARAMARK_PUBLIC_WORKOS_CLIENT_ID, PARAMARK_PUBLIC_WORKOS_REDIRECT_URI } = process.env;

/**
 * Wrapper hook around useAuth that provides signOut with default arguments.
 * Use this hook instead of useAuth directly to get signOut with default returnTo.
 */
export function useAuthWithDefaults() {
  const auth = useAuth();

  return {
    ...auth,
    signIn: () => {
      return auth.signIn({ state: { returnTo: location.pathname } });
    },
    signOut: () => {
      return auth.signOut({
        returnTo: window.location.origin,
      });
    },
  };
}

export function AuthProvider({ children }: { children: React.ReactNode }) {
  const navigate = useNavigate();
  return (
    <AuthKitProvider
      clientId={PARAMARK_PUBLIC_WORKOS_CLIENT_ID as string}
      redirectUri={PARAMARK_PUBLIC_WORKOS_REDIRECT_URI}
      onRedirectCallback={(params) => {
        if (
          params.state &&
          typeof params.state === 'object' &&
          params.state !== null &&
          'returnTo' in params.state &&
          typeof params.state.returnTo === 'string'
        ) {
          navigate(params.state.returnTo);
        }
      }}
    >
      {children}
    </AuthKitProvider>
  );
}
